'use client';

import Link from 'next/link';
import { MailCheck } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';

type Props = {
  email: string;
  locale: string;
};

export function RegisterSuccessPanel({ email, locale }: Props) {
  const t = useTranslations('auth.register');

  return (
    <div role="status" className="flex flex-col items-center gap-3 text-center">
      <MailCheck className="size-10 text-primary" aria-hidden />
      <h2 className="text-base font-medium">{t('success.title')}</h2>
      <p className="text-sm text-muted-foreground">{t('success.body')}</p>
      <p className="text-xs text-muted-foreground">
        {t('success.email_label')}: <span className="font-medium">{email}</span>
      </p>
      <Button asChild className="mt-2 h-11 w-full rounded-lg text-[14px]">
        <Link href={`/${locale}/verify-email?email=${encodeURIComponent(email)}`}>
          {t('success.verify_email')}
        </Link>
      </Button>
      <Link
        href={`/${locale}/login`}
        className="text-xs text-muted-foreground hover:text-foreground underline-offset-4 hover:underline"
      >
        {t('success.go_to_login')}
      </Link>
    </div>
  );
}
